import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import "react-datepicker/dist/react-datepicker.css";
import { changeDateFormat} from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import messages from '../.././../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import  {generateBullReportExcel}  from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';

function BullReport() {
    // const token = useContext(MyContextProvider).token;
    const decode_token = getUserClaimsForUi();
    const token = decode_token
    // const decode_token = jwtDecode(token);
    const [years, setYears] = useState([]);
    const [yearName, setYearName] = useState("");
    const [reportName, setReportName] = useState("");
    const storedLanguage = localStorage.getItem('language');
    const navigate = useNavigate();
    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //     },
    // };
    const config = getAuthHeaders();


useEffect(() => {
    const getYearList = () => {
    setYears(getAllYears());
    };
    getYearList();
}, []);




    //get Years 
const getAllYears = () => {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];
    for (let year = currentYear; year >= 2001; year--) {
        yearsArray.push(year);
    }
    return yearsArray;
};  

   
//get next Years 
const getNextYear = (year) => {
    const nextYear = parseInt(year) + 1;
    // const nextYearShort = nextYear.toString().slice(-2);
    const nextYearShort = nextYear.toString();
    return `${year} - ${nextYearShort}`;
};



    // Handle on change Event ********
    const handleDropdownChange = (e) => {
    
        switch (e.target.name) {
            case "yearName":
            setYearName(e.target.value);
            break;
            case "reportName":
            setReportName(e.target.value);
            break;
        default:
            console.log("switch case are not match");
            break;
        }
     };



 // Function to generate Excel file using mapped data
const handleGenerateExcel = async () => {
  
    if (!yearName) {
        toast.error("Please select a Survey Year", messages.COLOR_RED);
        return;
    }

   try{

        let postData = {
            year: yearName
         }
        showLoading(true);
        const response = await axios.post(`${API_URL}api/price/bullReport`, postData, config);
        const allData = response.data;
                downloadReport(allData.data,yearName)
    } catch (error) {
       console.error(error);
       toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
      showLoading(false);
    }

}

  // handle Download All report Data ****************
  const downloadReport=(allData,yearName)=>{
    let year=getNextYear(yearName);
    let reportData=allData.groupCodes[0].groupCodes.map(item => [
        item.MARKET_CODE,
        item.DISTRICT_NAME,
        item.APR_D, item.MAY_D, item.JUN_D, item.JUL_D, item.AUG_D, item.SEP_D, 
        item.OCT_D, item.NOV_D, item.DEC_D, item.JAN_D, item.FEB_D,  item.MAR_D,
        item.avg_D_C,
        item.APR_F, item.MAY_F, item.JUN_F, item.JUL_F, item.AUG_F, item.SEP_F, 
        item.OCT_F, item.NOV_F, item.DEC_F, item.JAN_F, item.FEB_F,  item.MAR_F,
        item.avg_g_C
        ]);

  let reportStructure = {
    year:yearName,
    fileName:`PricBullReport${yearName}`,
    fileType:'xls',
    sheetName: 'agriculture_party_bull',
    firstRowMergeCells: "A1:AB1",
    firstRowExportDate:  changeDateFormat(new Date()),
    secondRowMergeCells: "A2:AB2",
    secondRowText: `                                                                                 पशुधन-बैल देशी तथा ग्रेडेड मूल्य रु0 प्रति जोड़ी (आधार वर्ष 2011-12=100)`,
    thirdRowText:[
        'देशी बैल-वर्ष',
        `${year}`,
        'गे्रडेड बैल-वर्ष',
        `${year}`
    ],
    headerEnglishColumns: [
        'बाजार',
        'जनपद', 
        'APR','MAY', 'JUN', 'JUL','AUG','SEP',
        'OCT', 'NOV','DEC', 'JAN','FEB', 'MAR',
        'Average', 
        'APR','MAY','JUN', 'JUL','AUG','SEP',
        'OCT','NOV', 'DEC','JAN', 'FEB', 'MAR',
        'Average'
  ],
  excelRowData:reportData
}

   generateBullReportExcel(reportStructure)
 }



  return (
    <>
    <ToastContainer />
    <GlobalLoading />
    <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
            <div className="card-body pb-1">
                <div className="row align-items-center">
                    <h4 className="page_heading">
                     <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.BULL_REPORT : priceTitle.en.BULL_REPORT }} />
              
                    </h4>
                    <div className="row align-items-center">
                        

                        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                            <label className="fw-bold h6">Select Financial Year</label>
                            <select
                            name="yearName"
                            className="form-select"
                            onChange={handleDropdownChange}
                            value={yearName}
                            >
                            <option value="" disabled>Select Month</option>
                                 {years &&
                                  years.map((ele, index) => (
                                 <option key={index} value={ele}>
                                    {getNextYear(ele)}
                                 </option>
                                 ))}
                         </select>
                        </div>



                        <div className="col-xl-2 col-lg-4 mb-3">
                            <label className="w-100 d-none d-sm-block">&nbsp;</label>
                            <button onClick={handleGenerateExcel} className="btn btn_orange">Search</button>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
   </>
  )
}

export default BullReport